// extracted by mini-css-extract-plugin
module.exports = {"mdBreakPoint":"992","container":"pkY_siHcXjEMdHVa","paragraph":"f6dS0NEIjZVZyqEy","contact":"_1M_ITTxp7-bkCI1A","telephone":"_2345_Q5kn_TvLN4y"};